import client from "@/utils/client";

export const getSinglePackage = (id: string) => {
  return client.get(`/common/get-package/${id}`);
};
